'use client';

import React, { Dispatch, SetStateAction, useState } from 'react';

import { createGenericContext } from '../generateContext';

type ContextInterface = {
  puanExtraBannerStatus: boolean;
  setPuanExtraBannerStatus: Dispatch<SetStateAction<boolean>>;
};

const [useInsiderBannerContext, InsiderBannerContextProvider] =
  createGenericContext<ContextInterface>();

const InsiderBannerProvider = (
  props: React.PropsWithChildren<unknown>
): React.JSX.Element => {
  const [puanExtraBannerStatus, setPuanExtraBannerStatus] = useState(false);

  return (
    <InsiderBannerContextProvider
      value={{
        puanExtraBannerStatus,
        setPuanExtraBannerStatus,
      }}
    >
      {props.children}
    </InsiderBannerContextProvider>
  );
};
export { useInsiderBannerContext, InsiderBannerProvider };
